import { RouterView } from 'vue-router'

export default [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'side-nav' },
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/rag',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'RAG',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/rag/index.vue')
      }
    ]
  },
  {
    path: '/servicerequests/:status',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Service Requests',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/servicerequests/index.vue')
      }
    ]
  },
  {
    path: '/servicerequest/:id',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Service Request',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/servicerequests/upsert.vue')
      }
    ]
  },
  {
    path: '/calibration/:id',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Calibration',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/calibration/index.vue')
      }
    ]
  },
  {
    path: '/processcalibration/:id',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Process Calibration',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/calibration/process.vue')
      }
    ]
  },
  {
    path: '/chats',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Chats',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/chat/index.vue')
      }
    ]
  },
  {
    path: '/location',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Location',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/location/index.vue')
      }
    ]
  },
  {
    path: '/user',
    name: 'User Profile',
    meta: { layout: 'logo-only' },
    component: () => import('@/pages/user/index.vue')
  },
  {
    path: '/scanpro',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'ScanPro Assist',
        meta: { layout: 'side-nav', conditionalRoute: true },
        component: () => import('@/pages/scanpro/index.vue')
      }
    ]
  },
  {
    path: '/about',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'About',
        meta: { layout: 'side-nav' },
        component: () => import('@/pages/about/index.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { allowAnonymous: true, layout: 'no-nav' },
    component: () => import('@/pages/login/index.vue')
  },
  {
    path: '/connect',
    name: 'Connect',
    meta: { layout: 'no-nav' },
    component: () => import('@/pages/connect/index.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page not Found',
    component: () => import('@/pages/errors/error-404.vue')
  }
]
